import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { SchoolBreakEditView } from '@/modules/schoolSettings'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute(
  '/_auth/school-settings/breaks/$breakId/edit'
)({
  component: SchoolBreakEditView,
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.edit-school-break', { ns: 'schoolSettings' })
    ])
})
